@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details">
        <div
            class="screens"
            [attr.name]="'detail.menuAsset' | t"
            menuicon="fas fa-cube"
            menusystemsubmenu
        >
            <div
                [attr.name]="'detail.menuDetails' | t"
                menuItemId="details"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                @if (model) {
                    <app-cerrix-header
                        data-uiid="asset-detail-name"
                        [title]="model.name"
                        [edit]="false"
                        [breadcrumbs]="breadcrumbs"
                        [editIcon]="editIconFor('general')"
                        (editRequested)="editSection('general')"
                    ></app-cerrix-header>
                    <div class="body">
                        <div class="tabs-container-block">
                            <div class="meta-data-detail-screen">
                                <div class="meta-data-content">
                                    <app-cerrix-user-select
                                        name="asset-assigned"
                                        data-uiid="asset-detail-owner"
                                        [readonly]="true"
                                        [editIcon]="editIconFor('processInformation')"
                                        (editRequested)="editSection('processInformation')"
                                        [types]="assignedTypes"
                                        [value]="assignedValue"
                                        [label]="
                                            'register.assignedLabel' | t
                                        "
                                        [infoText]="'detail.assignedInfo' | t"
                                        [dialogTitle]="
                                            'register.assignedLabel' | t
                                        "
                                        [emptyText]="
                                            'edit-ownership-information.ownerSelectorEmptyText'
                                                | t
                                        "
                                    ></app-cerrix-user-select>
                                </div>
                                <div class="meta-data-content">
                                    <div class="meta-data-label">
                                        <span>{{
                                            "detail.dateInUseLabel" | t
                                        }}</span>
                                        @if (editIconFor("lifecycle"); as editIcon) {
                                            <cerrix-icon-button
                                                data-uiid="asset-detail-date-in-use-edit-button"
                                                [icon]="editIcon"
                                                [ariaLabel]="'detail.editButton' | t"
                                                buttonSize="small"
                                                [showBorder]="false"
                                                (click)="editSection('lifecycle')"
                                            />
                                        }
                                    </div>
                                    <div class="meta-data-values">
                                        <span data-uiid="asset-detail-date-in-use">{{
                                            model.lifecycle?.dateInUse | date: "dd-MM-yyyy"
                                        }}</span>
                                    </div>
                                </div>
                                <div class="meta-data-content">
                                    <div class="meta-data-label">
                                        <span>{{
                                            "detail.dateOutOfUseLabel" | t
                                        }}</span>
                                        @if (editIconFor("lifecycle"); as editIcon) {
                                            <cerrix-icon-button
                                                data-uiid="asset-detail-date-out-of-use-edit-button"
                                                [icon]="editIcon"
                                                [ariaLabel]="'detail.editButton' | t"
                                                buttonSize="small"
                                                [showBorder]="false"
                                                (click)="editSection('lifecycle')"
                                            />
                                        }
                                    </div>
                                    <div class="meta-data-values">
                                        <span data-uiid="asset-detail-date-out-of-use">{{
                                            model.lifecycle?.dateOutOfUse | date: "dd-MM-yyyy"
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <app-asset-tabs-header
                                [(selectedTab)]="selectedTab"
                            ></app-asset-tabs-header>
                            <div class="tabs-detail-block">
                                @switch (selectedTab) {
                                    @case ("overview") {}
                                    @case ("assessments") {}
                                    @case ("linkedItems") {
                                        <app-asset-linked-items-section [assetId]="id" />
                                    }
                                    @case ("documentandhyperlinks") {
                                        <app-asset-document-hyperlink-toggle
                                            [model]="model"
                                            [canEdit]="canEdit"
                                            (hyperlinksChanged)="onHyperlinksChanged($event)"
                                        ></app-asset-document-hyperlink-toggle>
                                    }
                                    @case ("history") {}
                                }
                            </div>
                        </div>
                        <div class="details-block">
                            <div class="details-header">
                                {{ "detail.detailsTitle" | t }}
                            </div>
                            <div class="details-content">
                                <div class="details-row full-width">
                                    <div class="details-title-row">
                                        <span class="details-title">{{
                                            "detail.descriptionValueLabel" | t
                                        }}</span>
                                        @if (editIconFor("general"); as editIcon) {
                                            <cerrix-icon-button
                                                data-uiid="asset-detail-description-edit-button"
                                                [icon]="editIcon"
                                                [ariaLabel]="'detail.editButton' | t"
                                                buttonSize="small"
                                                [showBorder]="false"
                                                (click)="editSection('general')"
                                            />
                                        }
                                    </div>
                                    <span class="details-value" data-uiid="asset-detail-description">{{ model.description }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "detail.thirdPartyValueLabel" | t
                                    }}</span>
                                    @if (editIconFor("general"); as editIcon) {
                                        <cerrix-icon-button
                                            data-uiid="asset-detail-third-party-edit-button"
                                            [icon]="editIcon"
                                            [ariaLabel]="'detail.editButton' | t"
                                            buttonSize="small"
                                            [showBorder]="false"
                                            (click)="editSection('general')"
                                        />
                                    }
                                    <span class="details-value" data-uiid="asset-detail-third-party">{{ thirdPartyName }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "detail.contractValueLabel" | t
                                    }}</span>
                                    @if (editIconFor("general"); as editIcon) {
                                        <cerrix-icon-button
                                            data-uiid="asset-detail-contract-edit-button"
                                            [icon]="editIcon"
                                            [ariaLabel]="'detail.editButton' | t"
                                            buttonSize="small"
                                            [showBorder]="false"
                                            (click)="editSection('general')"
                                        />
                                    }
                                    <span class="details-value" data-uiid="asset-detail-contract">{{ contractNumber }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "detail.organizationOwnerValueLabel"
                                            | t
                                    }}</span>
                                    @if (editIconFor("ownership"); as editIcon) {
                                        <cerrix-icon-button
                                            data-uiid="asset-detail-organization-owner-edit-button"
                                            [icon]="editIcon"
                                            [ariaLabel]="'detail.editButton' | t"
                                            buttonSize="small"
                                            [showBorder]="false"
                                            (click)="editSection('ownership')"
                                        />
                                    }
                                    <span class="details-value" data-uiid="asset-detail-organization-owner">{{
                                        getOrgOwnerName(
                                            model.ownershipInformation.owningOrganizationId
                                        )
                                    }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "detail.organizationsInUseValueLabel"
                                            | t
                                    }}</span>
                                    @if (editIconFor("processInformation"); as editIcon) {
                                        <cerrix-icon-button
                                            data-uiid="asset-detail-organizations-in-use-edit-button"
                                            [icon]="editIcon"
                                            [ariaLabel]="'detail.editButton' | t"
                                            buttonSize="small"
                                            [showBorder]="false"
                                            (click)="editSection('processInformation')"
                                        />
                                    }
                                    <span class="details-value" data-uiid="asset-detail-organizations-in-use">{{ organizationsInUseNames() }}</span>
                                </div>
                                <div class="details-row">
                                    <span class="details-title">{{
                                        "detail.businessDimensionValueLabel"
                                            | t
                                    }}</span>
                                    @if (editIconFor("processInformation"); as editIcon) {
                                        <cerrix-icon-button
                                            data-uiid="asset-detail-business-dimensions-edit-button"
                                            [icon]="editIcon"
                                            [ariaLabel]="'detail.editButton' | t"
                                            buttonSize="small"
                                            [showBorder]="false"
                                            (click)="editSection('processInformation')"
                                        />
                                    }
                                    <span class="details-value" data-uiid="asset-detail-business-dimensions">{{ businessDimensionNames() }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <cerrix-page-footer>
                        <div class="asset-management-footer">
                            <div class="left-button-group">
                                @if (canEdit) {
                                    <cerrix-button
                                        buttonType="secondary"
                                        buttonSize="big"
                                        secondaryColor="outlined-gray"
                                        data-uiid="asset-management-edit-asset"
                                        icon="edit"
                                        iconPosition="right"
                                        [text]="'detail.editButton' | t"
                                        (click)="edit()"
                                    >
                                    </cerrix-button>
                                }
                            </div>
                        </div>
                    </cerrix-page-footer>
                    @if (canEdit) {
                        <app-cerrix-slide-out-edit-item
                            #slideOut
                            [title]="'detail.editTitle' | t"
                            [isOpen]="editActive"
                            (isOpenChange)="closeCancel()"
                            [(items)]="sections"
                        >
                            @if (editActive) {
                                @switch (sections.activeItem) {
                                    @case ("general") {
                                        <app-edit-asset-general-information
                                            [model]="model"
                                            (modelChange)="onModelChange($event)"
                                            (closeEdit)="slideOut.requestClose()"
                                        ></app-edit-asset-general-information>
                                    }
                                    @case ("lifecycle") {
                                        <app-edit-asset-lifecycle-information
                                            [model]="model"
                                            (modelChange)="model = $event"
                                            (closeEdit)="slideOut.requestClose()"
                                        ></app-edit-asset-lifecycle-information>
                                    }
                                    @case ("processInformation") {
                                        <app-edit-asset-process-information
                                            [model]="model"
                                            (modelChange)="onProcessInformationChange($event)"
                                            (closeEdit)="slideOut.requestClose()"
                                        ></app-edit-asset-process-information>
                                    }
                                    @case ("ownership") {
                                        <app-edit-asset-ownership-information
                                            [model]="model"
                                            (modelChange)="onOwnershipChange($event)"
                                            (closeEdit)="slideOut.requestClose()"
                                        ></app-edit-asset-ownership-information>
                                    }
                                }
                            }
                        </app-cerrix-slide-out-edit-item>
                    }
                }
            </div>
        </div>
    </div>
}
